import { DateRangeActionTypes } from './constants';
import { defaultState } from './reducer.defaultState';
import { getDateRangeCacheDictionaryKey } from './selectors';

export const dateRange = (state = defaultState(), action) => {
  switch (action.type) {
    case DateRangeActionTypes.FETCH_DATE_RANGE_SUCCESS:
      return {
        ...state,
        [getDateRangeCacheDictionaryKey(
          action.currentLevel,
          action.currentDealerId,
        )]: action.result,
      };
    case DateRangeActionTypes.FETCH_DATE_RANGE_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case DateRangeActionTypes.RESET_DATE_RANGE:
      return {
        ...state,
        ...defaultState(),
      };
    default:
      return state;
  }
};
